import { Component } from '@angular/core';

@Component({
  selector: 'tools-card',
  templateUrl: './tools-card.component.html',
  styleUrls: ['./tools-card.component.scss']
})
export class ToolsCardComponent {}
